import * as React from 'react';
import { Helmet } from 'react-helmet';

const MunchkinScript = (): JSX.Element => {
  return (
    <Helmet name="Munchkin Tracking">
      <script>{`
          function triggerMunchkinProductInterest() {}
          if (window.Munchkin) {
            console.log('Munchkin should be ready')
          } else if (!window.Munchkin) {
            (function() {
              var didInit = false;
              function initMunchkin() {
                if(didInit === false) {
                  didInit = true;
                  Munchkin.init('025-XKO-469');
                }
              }
              var s = document.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = '//munchkin.marketo.net/munchkin.js';
              s.onreadystatechange = function() {
                if (this.readyState == 'complete' || this.readyState == 'loaded') {
                  initMunchkin();
                }
              };
              s.onload = initMunchkin;
              document.getElementsByTagName('head')[0].appendChild(s);
              })();
          }
      `}</script>
    </Helmet>
  );
};

export default MunchkinScript;
